// Functions ///////////////////////////////////////////////////////////

export function getValidCountryCodes(mapObj, data) {
  const validCountryCodes = data.filter((country) => {
    return mapObj.regions[country.country_code] !== undefined;
  });

  return validCountryCodes;
}

// Check if country code is found in countries from data attribute
export function countryCodeFound(data, code, returnObject = false) {
  const found = data.filter((item) => {
    return item.country_code === code;
  });

  if (found.length > 0) {
    if (returnObject) {
      return found[0];
    } else {
      return true;
    }
  }

  return false;
}

// Get country name by country code
export function getCountryNameByCode(data, code) {
  const found = data.filter((item) => {
    return item.country_code === code;
  });

  if (found.length > 0) {
    return found[0].name;
  }

  return "";
}

// Get country object by country code
export function getCountryObjectByCode(data, code) {
  const found = data.filter((item) => {
    return item.country_code === code;
  });

  if (found.length > 0) {
    return found[0];
  }

  return [];
}

// Append content to map tooltip
export function appendMapTooltip(tooltip, content, tooltipType = null) {
  const tip = tooltip.find(".map-tooltip--content");
  var spacing = "";

  tip.html("");
  if (tooltipType) {
    tooltip.attr("data-tooltip-type", tooltipType);
  } else {
    tooltip.removeAttr("data-tooltip-type");
  }

  if (content.title !== undefined) {
    tip.append(
      '<div class="map-tooltip--title font-semibold">' +
        content.title +
        "</div>"
    );
  }

  if (content.subtitle !== undefined) {
    tip.append(
      '<div class="map-tooltip--subtitle mb-3">' + content.subtitle + "</div>"
    );
  }

  if (content.body !== undefined && content.body.length > 0) {
    content.body.map((item) => {
      tip.append('<div class="mt-3">' + item.text + "</div>");

      if (item.link_url !== undefined) {
        tip.append(
          '<div><a target="_blank" href="' +
            item.link_url +
            '" class="tema-text--link">' +
            item.link_text +
            "</a></div>"
        );
      }
    });
  }

  if (content.footer !== undefined) {
    tip.append('<div class="text-sm">' + content.footer + "</div>");
  }
}

// Mod map to add borders etc.
export function modMap(mapElm, strokeColor = "#C1C7D3") {
  const disabledColor = strokeColor;

  // Jammu and Kashmir custom region
  const jammuKashmir = document.createElementNS("http://www.w3.org/2000/svg", "path");

  jammuKashmir.setAttributeNS(
    null,
    "d",
    "m 615.09 192.34 l 0.721 0.358 l 2.314 2.839 l -0.239 2.145 l 0.98 1.566 l -0.031 0.849 l -1.35 -0.286 l -0.478 0.463 l 0.015 0.162 l -1.011 -0.694 l -1.497 0.008 l -1.496 -0.787 l -1.513 0.493 l -0.486 1.019 l -1.404 0.362 l -1.921 -1.311 l -0.784 0.134 l -2.162 -1.673 l -0.732 -1.737 l 0 -2.261 l 1.736 -0.724 l -1.501 -2.017 l -0.742 -0.018 l 0 -0.985 l 1.239 -1.24 l 1.722 -0.305 l 2.6 -0.82 l 1.6 1.16 l 0.97 2.34 l 3.45 0.97 z"
  );
  jammuKashmir.setAttributeNS(null, "fill", disabledColor);

  mapElm.find("svg").find("g").first().append(jammuKashmir);

  // Western Sahara custom border ///////////////////////////////////////////
  var borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

  borderPath.setAttributeNS(null, "id", "path-ma-eh-border");
  borderPath.setAttributeNS(null, "d", "M392.75 211.70 l6.7 0");
  borderPath.setAttributeNS(null, "stroke", "white");
  borderPath.setAttributeNS(null, "stroke-width", "0.5");
  borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");

  mapElm.find("svg").find("g").first().append(borderPath);

  // India Pakistan custom border
  borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

  borderPath.setAttributeNS(
    null,
    "d",
    "M609 201 l2 -0.5, 0.5 -1, 1.5 -0.5, 1.5 0.75, 1.5 0, 1.5 1"
  );
  borderPath.setAttributeNS(null, "stroke", "white");
  borderPath.setAttributeNS(null, "stroke-width", "0.5");
  borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
  borderPath.setAttributeNS(null, "fill", "transparent");

  mapElm.find("svg").find("g").first().append(borderPath); // Right border

  borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

  borderPath.setAttributeNS(
    null,
    "d",
    "M607 199.75 l-2.25 -1.75, -0.75 -1.75, 0 -2.25, 1.75 -0.75, -1.5 -2, -0.75 0, 0 -1, 2 -2"
  );
  borderPath.setAttributeNS(null, "stroke", "white");
  borderPath.setAttributeNS(null, "stroke-width", "0.5");
  borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
  borderPath.setAttributeNS(null, "fill", "transparent");

  mapElm.find("svg").find("g").first().append(borderPath); // Left border

  borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

  borderPath.setAttributeNS(null, "id", "path-pk-in-border");
  borderPath.setAttributeNS(null, "stroke", "white");
  borderPath.setAttributeNS(
    null,
    "d",
    "M607.5 199.75 l-2.0 -4.3, 1.5 -1.3, 4 0.85, 2.5 -0.5, 2 -1.75"
  );
  borderPath.setAttributeNS(null, "stroke-width", "0.5");
  borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
  borderPath.setAttributeNS(null, "fill", "transparent");

  mapElm.find("svg").find("g").first().append(borderPath);

  // Somalia and Somaliland bordser
  // borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

  // borderPath.setAttributeNS(null, "stroke", strokeColor);
  // borderPath.setAttributeNS(
  //   null,
  //   "d",
  //   "M540.4 265 l3 -3.5, 0.2 -5"
  // );
  // borderPath.setAttributeNS(null, "stroke-width", "1.0");
  // borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
  // borderPath.setAttributeNS(null, "fill", "transparent");

  // Somalia and Ethiopia bordser
  borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

  borderPath.setAttributeNS(null, "id", "path-et-so-border");
  borderPath.setAttributeNS(null, "stroke", strokeColor);
  borderPath.setAttributeNS(
    null,
    "d",
    "m 525.5 275.3 l 0.58 -0.67 l 1.67 -0.13 l 2.13 -1.69 l 3.41 -0.23 l 6.678 -6.9"
  );
  borderPath.setAttributeNS(null, "stroke-width", "1.5");
  borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
  borderPath.setAttributeNS(null, "fill", "transparent");

  mapElm.find("svg").find("g").first().prepend(borderPath);

  // Remove Somaliland from map
  mapElm.find('path[data-code="XS"]').remove();

  const RegionSO = mapElm.find('path[data-code="SO"]');

  // Replace Somalia with expanded area which includes Somaliland
  RegionSO.attr('d', 'm 525.13 288.48 l -1.13 -1.57 l -0.03 -8.86 l 2.66 -3.38 l 1.67 -0.13 l 2.13 -1.69 l 3.41 -0.23 l 7.08 -7.55 l -0.42 -0.67 l -1.941 0.014 l -8.035 -2.937 l -2.562 -3.149 l 1.121 -1.735 l 2.055 2.349 l 1.522 0.106 l 5.151 -0.961 l 5.259 -1.441 l 0.84 -0.086 l 2.98 -0.67 l 1.24 -0.86 l 0.45 0 l -0.2 3 l -1.21 3.62 l -2.73 5.97 l -2.13 3.65 l -5.03 6.16 l -8.56 6.4 l -2.78 3.08 l -0.8 1.56 z');

  const westernSaharaRegion = mapElm.find('path[data-code="EH"]');
  westernSaharaRegion.css('pointer-events', 'none');
  westernSaharaRegion.css('fill', disabledColor);




  // Sudan and South Sudan border
  borderPath = document.createElementNS("http://www.w3.org/2000/svg", "path");

  borderPath.setAttributeNS(null, "id", "path-sd-ss-border");
  borderPath.setAttributeNS(null, "stroke", strokeColor);
  borderPath.setAttributeNS(
    null,
    "d",
    "M 481.149 263.157 l 1.27 -0.743 l 0.695 -2.11 l 0.527 -1.126 l 1.774 -0.408 l 1.822 2.086 l 0.575 0.239 l 1.079 -0.407 l 1.629 0.096 l 0.528 0.503 l 2.205 0.024 l 0.359 -0.551 l 1.127 -0.408 l 0.455 -0.934 l 0.695 -0.312 l 2.206 1.294 l 1.246 -0.12 l 2.637 -3.187 l -0.192 -1.558 l -0.264 -0.528 l 0.12 -0.263 l 1.007 -0.144 l 0.623 -0.432 l 0.815 0.12 l -0.312 1.798 l 0.312 1.726 l 1.27 1.102 l 0.192 0.671"
  );
  borderPath.setAttributeNS(null, "stroke-width", "1.5");
  borderPath.setAttributeNS(null, "stroke-dasharray", "0.5, 0.5");
  borderPath.setAttributeNS(null, "fill", "transparent");

  mapElm.find("svg").find("g").first().prepend(borderPath);
}

export function modMapColorBorder(mapElm) {
  // Change color of border for Somalia and Somaliland
  const soRegion = mapElm.find('path[data-code="SO"]');
  const etRegion = mapElm.find('path[data-code="ET"]');

  let color;

  if (soRegion.attr('fill') > etRegion.attr('fill')) {
    color = soRegion.attr('fill');
  } else {
    color = etRegion.attr('fill');
  }

  document.getElementById('path-et-so-border').setAttribute('stroke', color);

  // Change color of border for Sudan and South Sudan
  const sdRegion = mapElm.find('path[data-code="SD"]');
  const ssRegion = mapElm.find('path[data-code="SS"]');

  if (sdRegion.attr('fill') > ssRegion.attr('fill')) {
    color = sdRegion.attr('fill');
  } else {
    color = ssRegion.attr('fill');
  }

  document.getElementById('path-sd-ss-border').setAttribute('stroke', color);

  // Change color of border for India and Pakistan
  const inRegion = mapElm.find('path[data-code="IN"]');
  const pkRegion = mapElm.find('path[data-code="PK"]');

  if (inRegion.attr('fill') > pkRegion.attr('fill')) {
    color = inRegion.attr('fill');
  } else {
    color = pkRegion.attr('fill');
  }

  // document.getElementById('path-pk-in-border').setAttribute('stroke', color);
}

export function darkenColor(color, percent) {
  var r = parseInt(color.slice(1, 3), 16);
  var g = parseInt(color.slice(3, 5), 16);
  var b = parseInt(color.slice(5, 7), 16);

  r = Math.round(r * (1 - percent / 100));
  g = Math.round(g * (1 - percent / 100));
  b = Math.round(b * (1 - percent / 100));

  var darkenedColor =
    "#" +
    (r < 16 ? "0" : "") +
    r.toString(16) +
    (g < 16 ? "0" : "") +
    g.toString(16) +
    (b < 16 ? "0" : "") +
    b.toString(16);

  return darkenedColor;
}

export function isValidDateFormat(input, format = "date") {
  const yearRegex = /^\d{4}$/; // YYYY
  const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD

  const inputFormatRegex = format === "year" ? yearRegex : dateFormatRegex;
  const date = new Date(input);

  return (
    inputFormatRegex.test(input) &&
    !isNaN(date) &&
    date instanceof Date &&
    isFinite(date)
  );
}

export function flagCdn(c, s = 'w160') {
  const code = c.toLowerCase();
  const exceptions = ['af', 'xs'];

  if (exceptions.includes(code)) {
    return "/themes/custom/tema/src/assets/flags/" + code + ".png"
  } else {
    return "https://flagcdn.com/"+ s + "/" + code + ".png";
  }
}



// Variables ///////////////////////////////////////////////////////////

export const markerStyle = {
  initial: {
    fill: "#F38336",
    stroke: "white",
    "stroke-width": 5,
    r: 10,
  },
  hover: {
    stroke: "white",
    fill: "#F38336",
    "stroke-width": 5,
    r: 12,
    cursor: "pointer",
  },
};

export const regionStyle = {
  initial: {
    fill: "#C1C7D3",
    "fill-opacity": 1,
    stroke: "none",
    "stroke-width": 0,
    "stroke-opacity": 1,
  },
};

export function getSpanishCountryName(code) {
  const countries = require('./../json/countries.json').countries;

  const country = countries.find((c) => {
    return c.code_2 === code;
  });

  if (country !== undefined && country !== null) {
    return country.name_es;
  }

  return '';
};

export function getSpanishRegionName(region) {
  const regions = require('./../json/regions.json').regions;

  console.log('region', region);
  console.log('regions', regions);

  const regionEs = regions.find((r) => {
    return r.region_en === region;
  });

  if (regionEs !== undefined && regionEs !== null) {
    return regionEs.region_es;
  }

  return region;
};

export function getSpanishMemberStateLabel(ms) {
  switch (ms) {
    case 'Yes':
      return 'Estado miembro';
    case 'Chair':
      return 'Presidente';
    case 'First Vice Chair':
      return 'Primer Vicepresidente';
    case 'Observer':
      return 'Observador';
  }

  return '';
}

export const getCSRFTokenValue = async () => {
  let token = null;

  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  await fetch(`${baseUrl}/session/token`)
  
    .then((response) => {
      token = response.text();
    })
    .catch((error) => {
      console.error("Error fetching CSRF token:", error);
    });

  return token;
};